export default __webpack_public_path__ + "static/hero-bg-right-fc966d06574d1660a9e27b59c2611f2f.png";